import { render } from "./BasicConfig.vue?vue&type=template&id=15a610e0&scoped=true"
import script from "./BasicConfig.vue?vue&type=script&lang=js"
export * from "./BasicConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a610e0"]])

export default __exports__